<template>
  <div>
    <message :messages="messages"></message>
    <v-card>
      <v-card-title>
        <div class="body-2">{{labels.quoteInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.product" v-model="packageForm.product" :label="labels.product" item-text="label" item-value="value" data-vv-name="product" :data-vv-as="labels.product" :error-messages="errors.collect('product')" v-validate="'required'" @input="doProduct"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.scheme" v-model="packageForm.scheme" :label="labels.scheme" item-text="label" item-value="value" data-vv-name="scheme" :data-vv-as="labels.scheme" :error-messages="errors.collect('scheme')" v-validate="'required'" @input="doScheme" :loading="schemeLoading" :hint="labels.schemeInfo" persistent-hint></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-layout row wrap>
                <v-flex xs7 v-if="isStaff">
                  <cal-picker v-model="acceptDate" :label="labels.acceptDate"  v-validate="'required'" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['packageQuoteAcceptDate'])" @input="doAcceptDate" ></cal-picker>
                  <!--cal-picker v-model="acceptDate" :label="labels.acceptDate"  v-validate="'required|accept_today_date'" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['packageQuoteAcceptDate'])" @input="doAcceptDate" :max="minStartDate"></cal-picker-->
                </v-flex>
                 <v-flex xs7 v-else>
                  <cal-picker v-model="acceptDate" :label="labels.acceptDate" v-validate="acceptDateValidation" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['packageQuoteAcceptDate'])" @input="doAcceptDate" :min="this.backDateLimit" ></cal-picker>
                  <!--cal-picker v-model="acceptDate" :label="labels.acceptDate" v-validate="acceptDateValidation" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['packageQuoteAcceptDate'])" @input="doAcceptDate" :min="this.backDateLimit" :max="minStartDate"></cal-picker-->
                </v-flex>
                <v-flex xs5>
                  <time-picker v-model="acceptTime" :label="labels.acceptTime" v-validate="'required'" :data-vv-as="labels.acceptTime" data-vv-name="acceptTime" :error-messages="errors.collect('acceptTime')" :readonly="!checkAccess(['packageQuoteAcceptDate'])" @input="doAcceptDate"></time-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="packageForm.startDate" :label="labels.startDate" v-validate="startDateValidation" :data-vv-as="labels.startDate" data-vv-name="startDate" :error-messages="errors.collect('startDate')" @input="doStartDate" :min="this.acceptDate" :max="maxStartDate"></cal-picker>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="packageForm.endDate" :label="labels.endDate" v-validate="endDateValidation" :data-vv-as="labels.endDate" data-vv-name="endDate" :error-messages="errors.collect('endDate')" :min="this.packageForm.startDate" :hint="daysCoverage"></cal-picker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-title>
        <div class="body-2">{{labels.cpInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.campaign" v-model="packageForm.campaign" :label="labels.campaign" item-text="label" item-value="value" data-vv-name="campaign" :data-vv-as="labels.campaign" :error-messages="errors.collect('campaign')" clearable :loading="campaignLoading" @input="doCampaign"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.promotion" v-model="packageForm.promotion" :label="labels.promotion" item-text="label" item-value="value" data-vv-name="promotion" :data-vv-as="labels.promotion" :error-messages="errors.collect('promotion')" clearable :loading="promotionLoading"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="mt-3">
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed" :disabled="proceedLoading">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import toDate from 'date-fns/toDate'
import addYears from 'date-fns/addYears'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'
import differenceInDays from 'date-fns/differenceInDays'
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_PACKAGE_PARAM_GENERAL, QUOTE_PACKAGE_PARAM } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { expandURI } from '@/utils/ajax'
import { extractRecord } from '@/utils/extract'
import { formatDisplayTime, formatDisplayDateTime2 } from '@/utils/date'
export default {
  data() {
    return {
      labels: {
        product: 'Product*',
        scheme: 'Scheme*',
        schemeInfo: 'Business/Trade',
        acceptDate: 'Acceptance Date*',
        acceptTime: 'Time*',
        startDate: 'Start Date*',
        endDate: 'End Date*',
        quoteInfo: 'Quotation Information',
        cpInfo: 'Campaign/Promotion',
        campaign: 'Campaign',
        promotion: 'Promotion'
      },
      packageForm: {
        product: undefined,
        scheme: undefined,
        acceptDate: undefined,
        startDate: undefined,
        endDate: undefined,
        campaign: undefined,
        promotion: undefined
      },
      acceptDate: undefined,
      acceptTime: undefined,
      schemeLoading: false,
      campaignLoading: false,
      promotionLoading: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    acceptDateValidation() {
      // const result = 'required|accept_back_date:' + this.backDateDays + '|accept_start_date:' + this.packageForm.startDate + '|accept_today_date'
      // return result
      // return 'required|accept_back_date:' + this.backDateDays + '|accept_today_date'
      return 'required|accept_back_date:' + this.backDateDays
    },
    quoteParam() {
      return this.$store.state.agency.quotation.packageParam
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    isStaff() {
      return this.$store.state.agency.quotationSettings.isStaff
    },
    proceedLoading() {
      if (this.schemeLoading || this.campaignLoading || this.promotionLoading) {
        return true
      } else {
        return false
      }
    },
    selectedProduct() {
      if (this.packageForm.product) {
        return extractRecord(this.quoteParam.product, this.packageForm.product)
      } else {
        return null
      }
    },
    backDateDays() {
      const product = this.selectedProduct
      if (product) {
        return product.backDateAcceptDays
      } else {
        return null
      }
    },
    backDateLimit() {
      if (this.backDateDays !== null || this.backDateDays !== undefined) {
        if (this.backDateDays === 0) {
          return new Date()
        } else {
          return subDays(new Date(), this.backDateDays)
        }
      } else return null
    },
    daysCoverage() {
      if (this.packageForm.startDate && this.packageForm.endDate) {
        return 'Days Covered: ' + (differenceInDays(toDate(this.packageForm.endDate), toDate(this.packageForm.startDate)) + 1)
      } else {
        return undefined
      }
    },
    daysBeforeCover() {
      if (this.packageForm.product) {
        const productParam = extractRecord(this.quoteParam.product, this.packageForm.product)
        if (productParam) {
          return productParam.maxDaysBeforeCover
        }
      }
      return undefined
    },
    minStartDate() {
      return new Date()
    },
    maxStartDate() {
      if (this.daysBeforeCover !== undefined) {
        let result = new Date()
        result.setHours(0, 0, 0, 0)
        result = addDays(result, this.daysBeforeCover)
        return result
      }
      return undefined
    },
    startDateValidation() {
      // return 'required|start_before_today|days_before_cover:' + this.daysBeforeCover
      return 'required|start_before_date:' + this.acceptDate + '|days_before_cover:' + this.daysBeforeCover
    },
    endDateValidation() {
      return 'required|start_enddate:' + this.packageForm.startDate
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      this.packageForm.product = this.globalCommonForm.product
      this.packageForm.scheme = this.globalCommonForm.scheme
      this.packageForm.acceptDate = this.globalCommonForm.acceptDate
      this.packageForm.startDate = this.globalCommonForm.startDate
      this.packageForm.endDate = this.globalCommonForm.endDate
      this.packageForm.campaign = this.globalCommonForm.campaign
      this.packageForm.promotion = this.globalCommonForm.promotion

      // Need break down acceptDate into date and time for input
      if (this.packageForm.acceptDate) {
        this.acceptDate = this.packageForm.acceptDate
        this.acceptTime = formatDisplayTime(this.packageForm.acceptDate)
      }

      // Check if there are already values in vuex form or if it is a fresh entry
      // For this case, we will just use product as an indicator (for review, there is already value saved)
      if (!this.packageForm.product) {
        if (this.quoteParam.product && this.quoteParam.product.length > 0) {
          // This is to load 1st value if its a fresh quotation
          this.packageForm.product = this.quoteParam.product[0].value
          this.doProduct()

          // Defaulting start Date
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          this.packageForm.startDate = today
          this.doStartDate()
        }

        this.$store.commit(QUOTE_PACKAGE_PARAM_GENERAL)
      } else {
        // If there are already values in vuex, we will check if we still need to load Package General Screen params
        if (!this.quoteParam.generalLoaded) {
          // doProduct will snowBall to get other params in general screen
          this.doProduct()

          this.$store.commit(QUOTE_PACKAGE_PARAM_GENERAL)
        }
      }
    },
    doProduct() {
      if (this.packageForm.product) {
        this.getScheme()
      } else {
        this.packageForm.scheme = undefined
        this.doScheme()
      }

      if (this.packageForm.acceptDate && this.packageForm.product) {
        this.getCampaign()
      } else {
        this.packageForm.campaign = undefined
        this.doCampaign()
      }
    },
    async getScheme() {
      const apiURI = this.$store.state.agency.quotation.menu.scheme
      if (apiURI) {
        try {
          this.schemeLoading = true
          const expand = {
            product: this.packageForm.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              scheme: data.data
            }
            this.$store.commit(QUOTE_PACKAGE_PARAM, commitResult)
          }
          this.schemeLoading = false

          // Defaulting for scheme (Default 1st if no value was set)
          if (!this.packageForm.scheme && this.packageForm.product && this.quoteParam.scheme && this.quoteParam.scheme.length > 0) {
            this.packageForm.scheme = this.quoteParam.scheme[0].value
          }

          if (this.packageForm.scheme && this.quoteParam.scheme && this.quoteParam.scheme.length > 0) {
            // Check if the current scheme value is still valid
            let schemeIsValid = false
            for (var i = 0; i < this.quoteParam.scheme.length; i++) {
              const scheme = this.quoteParam.scheme[i]
              if (scheme.value === this.packageForm.scheme) {
                schemeIsValid = true
                break
              }
            }
            // Invalid Scheme (reset to undefined)
            if (!schemeIsValid) {
              this.packageForm.scheme = undefined
              this.doScheme()
            } else {
              this.doScheme()
            }
          } else {
            this.packageForm.scheme = undefined
            this.doScheme()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.schemeLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doScheme() {
    },
    doStartDate() {
      if (this.packageForm.startDate) {
        // Add 1 year to end Date
        let endDate = addYears(this.packageForm.startDate, 1)
        endDate = subDays(endDate, 1)
        this.packageForm.endDate = endDate
      }
    },
    doAcceptDate() {
      // Format Accept Date
      if (this.checkAccess(['packageQuoteAcceptDate'])) {
        if (this.acceptDate && this.acceptTime && this.acceptTime.length === 5) {
          const hr = this.acceptTime.substring(0, 2)
          const min = this.acceptTime.substring(3, 5)
          this.acceptDate = toDate(this.acceptDate)
          this.acceptDate.setHours(hr)
          this.acceptDate.setMinutes(min)
          this.packageForm.acceptDate = this.acceptDate
        }
      }
      if (this.packageForm.product && this.packageForm.acceptDate) {
        this.getCampaign()
      } else {
        this.packageForm.campaign = undefined
        this.doCampaign()
      }
    },
    async getCampaign() {
      const apiURI = this.$store.state.agency.quotation.menu.campaign
      if (apiURI) {
        try {
          const expand = {
            product: this.packageForm.product,
            intermediary: this.globalCommonForm.intermediary,
            acceptDate: formatDisplayDateTime2(this.packageForm.acceptDate)
          }
          this.campaignLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              campaign: data.data
            }
            this.$store.commit(QUOTE_PACKAGE_PARAM, commitResult)
          }
          this.campaignLoading = false

          if (this.packageForm.campaign && this.quoteParam.campaign && this.quoteParam.campaign.length > 0) {
            // Check if the current campaign value is still valid
            let campaignIsValid = false
            for (var i = 0; i < this.quoteParam.campaign.length; i++) {
              const campaign = this.quoteParam.campaign[i]
              if (campaign.value === this.packageForm.campaign) {
                campaignIsValid = true
                break
              }
            }
            // Invalid Campaign (reset to undefined)
            if (!campaignIsValid) {
              this.packageForm.campaign = undefined
            } else { }
          } else {
            this.packageForm.campaign = undefined
          }
          // Do campaign (get promotion)
          this.doCampaign()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.campaignLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doCampaign() {
      if (this.packageForm.campaign && this.packageForm.acceptDate) {
        this.getPromotion()
      } else {
        this.packageForm.promotion = undefined
      }
    },
    async getPromotion() {
      const apiURI = this.$store.state.agency.quotation.menu.promotion
      if (apiURI) {
        try {
          const expand = {
            campaign: this.packageForm.campaign,
            acceptDate: formatDisplayDateTime2(this.packageForm.acceptDate)
          }
          this.promotionLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              promotion: data.data
            }
            this.$store.commit(QUOTE_PACKAGE_PARAM, commitResult)
          }
          this.promotionLoading = false

          if (this.packageForm.promotion && this.quoteParam.promotion && this.quoteParam.promotion.length > 0) {
            // Check if the current promotion value is still valid
            let promotionIsValid = false
            for (var i = 0; i < this.quoteParam.promotion.length; i++) {
              const promotion = this.quoteParam.promotion[i]
              if (promotion.value === this.packageForm.promotion) {
                promotionIsValid = true
                break
              }
            }
            // Invalid Promotion (reset to undefined)
            if (!promotionIsValid) {
              this.packageForm.promotion = undefined
            }
          } else {
            this.packageForm.promotion = undefined
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.resetMessages()
            this.message(data)
          }
          this.promotionLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if ((this.packageForm.campaign && this.packageForm.promotion) || (!this.packageForm.campaign && !this.packageForm.promotion)) {
            this.$store.dispatch('packageQuoteGeneral', this.packageForm)
            this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
            this.$router.push({ name: 'packageQuotePlans' })
          } else {
            this.errorMessage('Please select a promotion if this quotation is participating in a campaign')
            this.promptFieldCheck()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        await this.$store.dispatch('packageQuoteGeneral', this.packageForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 1) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style>
</style>
